import { styled } from "@mui/system";

const StepperIconRoot = styled("div")(({ theme, ownerState }) => {
  const {
    active,
    isStepCompleted = false,
    isCompleted1,
    isCompleted2,
    isCompleted3,
    variant, // "colorlib" or "default"
  } = ownerState;

  // --- Common base styles ---
  const baseStyles = {
    zIndex: 1,
    color: "#fff",
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[700] : "#fff",
  };

  // --- Default variant styles ---
  const defaultVariant = {
    border: isStepCompleted ? "2px solid #1A407D" : "2px solid #7A7A7A",
    width: 36,
    height: 36,
    backgroundColor: isStepCompleted
      ? "#1A407D"
      : theme.palette.mode === "dark"
      ? theme.palette.grey[700]
      : "#fff",
    ...(active && {
      background: isStepCompleted ? "#1A407D" : "#C9DEFF",
      borderColor: isStepCompleted ? "#1A407D" : "#C9DEFF",
      "& img": {
        filter: isStepCompleted
          ? ""
          : "invert(107%) sepia(132%) saturate(2698%) hue-rotate(209deg) brightness(86%) contrast(103%)",
      },
    }),
    cursor: isStepCompleted ? "pointer" : "default",
  };

  // --- Colorlib variant styles ---
  const colorlibVariant = {
    border: "2px solid #A5A5A5",
    width: 32,
    height: 32,
    ...(active && {
      background: "#C9DEFF",
      border: "1px solid transparent",
      "& img": {
        filter:
          "invert(107%) sepia(132%) saturate(2698%) hue-rotate(209deg) brightness(86%) contrast(103%)",
      },
    }),
    ...(isCompleted1 || isCompleted2 || isCompleted3
      ? {
          background: "#1A407D",
          border: "1px solid #1A407D",
          cursor: "pointer",
        }
      : {}),
  };

  return {
    ...baseStyles,
    ...(variant === "colorlib" ? colorlibVariant : defaultVariant),
  };
});

export default StepperIconRoot;
